$mol_view_tree2_to_js_test_ex_array_inheritance_foo $mol_object
	arr /
		\v1
$mol_view_tree2_to_js_test_ex_array_inheritance_bar $mol_view_tree2_to_js_test_ex_array_inheritance_foo
	arr /
		\v3
		^
		\v4
